module.exports = __webpack_public_path__ + "img/public/AdminIcons/eye.svg?99394394";